import { AriaAttributes, FC, FocusEvent, ReactElement, useRef } from 'react';

import Basket from '../Basket/Basket';
import { EcomOnly } from '../EcomOnly/EcomOnly';
import { JabraFocusGroup } from '../JabraFocus';
import { DesktopTopMenu, MobileTopMenu, useHeaderConfig, useHeaderNavigation } from '../MegaMenu';
import { SubmenuComponent } from './SubmenuComponent';

export interface AppHeaderProps {
  condensedMenu?: ReactElement;
}

export const AppHeader: FC<AppHeaderProps & AriaAttributes> = ({ condensedMenu, ...props }) => {
  const { isNavigationTransparent, showNavigation } = useHeaderConfig();
  const { closeMenu } = useHeaderNavigation();
  const headerRef = useRef<HTMLHeadingElement | null>(null);

  const handleHeaderBlur = (event: FocusEvent<HTMLElement>) => {
    if (!headerRef.current?.contains(event.relatedTarget)) {
      closeMenu();
    }
  };

  return (
    <header
      ref={headerRef}
      className="top-menu relative z-30 flex flex-col bg-white"
      onBlur={handleHeaderBlur}
      {...props}
    >
      <JabraFocusGroup orientation="both" id="header" className="z-30">
        <div className="flex content-center justify-between">
          <MobileTopMenu
            isNavigationTransparent={isNavigationTransparent?.value}
            showNavigation={showNavigation?.value}
          />
          <DesktopTopMenu
            isNavigationTransparent={isNavigationTransparent?.value}
            showNavigation={showNavigation?.value}
          />

          <EcomOnly>
            <Basket />
          </EcomOnly>
        </div>
        <SubmenuComponent headerRef={headerRef} />
      </JabraFocusGroup>
      {condensedMenu}
    </header>
  );
};
